const CodeAccess = (props) => {
  return (
    <section className="chart-card transaction-form-card">
      <h2 className="transaction-section-title">Par code</h2>
      <p className="transaction-section-hint">Entrez le code et, si nécessaire, un modificateur.</p>

      <form onSubmit={(event) => props.formCodeCompleteSubmitted(event)}>
        <div className="transaction-code-fields">
          <div className={`transaction-code-line${props.goodCode != null ? '' : ' transaction-code-line-no-status'}`}>
            {props.goodCode != null && (
              <span
                className={`transaction-status-icon${props.goodCode === 1 ? ' transaction-status-icon-valid' : ' transaction-status-icon-invalid'}`}
                aria-hidden="true"
              >
                <i className={`${props.goodCode === 1 ? 'far fa-check-circle' : 'fas fa-times-circle'}`}></i>
              </span>
            )}
            <input
              autoComplete="off"
              placeholder="Code"
              type="number"
              className="form-control transaction-code-input"
              id="inputCode"
              onChange={(e) => props.handleCodeChange(e)}
            />
          </div>
          <select
            className="form-control transaction-modif-select"
            id="inputModif"
            onChange={(e) => props.handleSelectModif(e)}
            value={props.modifSelect ? props.modifSelect : ''}
          >
            <option value="">-- Modificateur --</option>
            {props.allMod.map((e) => (
              <option key={e} value={e}>{e}</option>
            ))}
          </select>
        </div>

        {props.goodCode === 1 && (
          <input
            className="form-control transaction-desc-preview"
            type="text"
            value={props.codeDesc}
            readOnly
            aria-label="Description du code"
          />
        )}

        <div className="transaction-field transaction-field-inline">
          <label htmlFor="inputCodeQte">Quantité</label>
          <input
            placeholder="Quantité"
            type="number"
            className="form-control transaction-qte-input"
            id="inputCodeQte"
            value={props.qteCode}
            onChange={props.handleQteCode}
          />
        </div>

        <div className="transaction-field">
          <label htmlFor="inputCodeNotes">Notes</label>
          <textarea
            placeholder="Notes optionnelles"
            className="form-control"
            rows="4"
            id="inputCodeNotes"
          />
        </div>

        {props.saveSuccess && (
          <div className="transaction-success-banner" role="alert">
            La transaction a été enregistrée.
          </div>
        )}

        <div className="transaction-submit-row">
          <button type="submit" className="btn btn-primary">
            Valider
          </button>
        </div>
      </form>
    </section>
  );
};

export default CodeAccess;
